export default __webpack_public_path__ + "public/assets/images/bd25139a88c5c0462b24aee4e93e7b6e.png";